<h2>{{ "device.yourDevices" | translate }}</h2>
<div>
  <app-device *ngFor="let device of devices" [device]="device"></app-device>
  <app-device-adder></app-device-adder>
</div>
